import React from 'react';

const VideoPlayer = ({ src }) => {
  return (
    <video controls height='250'>
      <source src={src} />
      {/* {console.log('video', video)} */}
      {/* <source src='mov_bbb.ogg' type='video/ogg' /> */}
      Your browser does not support HTML5 video.
    </video>
  );
};

export default VideoPlayer;
